<template>
  <span
    class="resulticon"
    :class="getColor"
  >
    {{ getText }}
    <div class="toggle-tooltip">
      {{ getTextToolTip }}
    </div>
  </span>
</template>

<script>
export default {
  props: {
    value: String,
  },
  computed: {
    getColor: function() {
      let value = 'o28';
      switch(this.value) {
        case 'MAIN_SUMMER': value = 'o29'; break;
        case 'MAIN_AUTUMN': value = 'o30'; break;
        case 'MAIN_WINTER': value = 'o31'; break;
      }
      return value;
    },
    getText: function() {
      let value = 'X';
      switch(this.value) {
        case 'MAIN_SUMMER': value = 'H'; break;
        case 'MAIN_AUTUMN': value = 'T'; break;
        case 'MAIN_WINTER': value = 'Đ'; break;
      }
      return value;
    },
    getTextToolTip: function() {
      let value = 'Xuân';
      switch(this.value) {
        case 'MAIN_SUMMER': value = 'Hạ'; break;
        case 'MAIN_AUTUMN': value = 'Thu'; break;
        case 'MAIN_WINTER': value = 'Đông'; break;
      }
      return value;
    },
  },
}
</script>

